import { createReducer } from '@reduxjs/toolkit';
import * as actions from '@/store/actions';

const initialState = '';

export default createReducer(initialState, {
	[actions.setSearchTerm.type]: (draft, { payload }): void => payload,
});
